import {CreateItemRequestValue, ItemRequest, ItemRequestComment} from '@store/item-requests/item-requests.types';
import {FALLBACK_CATALOG_RECORD} from '@store/catalog/catalog.fallback';

export const FALLBACK_ITEM_REQUEST: ItemRequest = {
  id: 0,
  organizationId: 0,
  requestedBranchId: 0,
  patronId: 0,
  status: 'REQUESTED',
  title: '',
  author: '',
  isbn: '',
  materialTypeDesc: '',
  notes: '',
  hasUnreadStaffComments: false,
  active: false,
  created: '',
  modified: '',
  comments: [],
  pickupBranchName: '',
  linkedCatalogRecord: FALLBACK_CATALOG_RECORD,
  hasLinkedCatalogRecord: false,
  holdPlaced: false,
  decisionDate: '',
  printType: '',
  yearOfPublication: ''
};

export const FALLBACK_ITEM_REQUEST_COMMENT: ItemRequestComment = {
  id: 0,
  patronId: 0,
  userId: 0,
  patronItemRequestId: 0,
  comment: '',
  active: false,
  created: '',
  modified: ''
};

export const FALLBACK_CREATE_ITEM_REQUEST_VALUE: CreateItemRequestValue = {
  itemTitle: '',
  itemAuthor: '',
  requestedBranchId: 0,
  isbn: '',
  materialTypeDesc: '',
  yearOfPublication: '',
  printType: '',
  notes: '',
  confirmCheckbox: false
}
